import { businessTokens, type DimensionId } from "@benyishiguang/ui-foundation";
import { Anchor, Eye, Heart, Route, Sparkles } from "lucide-react";

type EvidenceItem = { kind: string; dim: DimensionId | null };
type DimensionEvidenceProps = {
	dimensionScores: Record<DimensionId, number>;
	timeline: readonly EvidenceItem[];
};

const dimensionIcons = {
	aware: Eye,
	strength: Sparkles,
	relate: Heart,
	resil: Anchor,
	hope: Route,
};

/** A presentation-only summary; callers own loading, persistence and evidence scoring. */
export function DimensionEvidence({ dimensionScores, timeline }: DimensionEvidenceProps) {
	const practiceItems = timeline.filter((item) => item.kind === "practice");
	const maxEvidence = Math.max(1, ...Object.values(dimensionScores));
	return (
		<>
			<div className="evidence-summary-head">
				<div>
					<strong>五维练习证据</strong>
					<span>按练习记录汇总，不代表能力高低</span>
				</div>
				<b>{practiceItems.length} 条</b>
			</div>
			<div className="evidence-compact-list">
				{businessTokens.dimensions.map((dimension) => {
					const Icon = dimensionIcons[dimension.id];
					const value = Math.max(0, dimensionScores[dimension.id] ?? 0);
					const count = practiceItems.filter((item) => item.dim === dimension.id).length;
					return (
						<div className="evidence-compact-row" key={dimension.id}>
							<span>
								<Icon aria-hidden="true" size={18} />
								{dimension.name}
							</span>
							<i aria-hidden="true">
								<b style={{ width: `${value ? Math.max(7, (value / maxEvidence) * 100) : 0}%` }} />
							</i>
							<em>{count}</em>
						</div>
					);
				})}
			</div>
		</>
	);
}
